import React from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

export interface CompletionChartPoint {
  t: string;
  completion: number;
  missed: number;
}

interface Props {
  data: CompletionChartPoint[];
}

export default function CompletionChart({ data }: Props): React.ReactElement {
  return (
    <div className="h-64 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 8, right: 8, left: -16, bottom: 0 }}>
          <defs>
            <linearGradient id="completionFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#00d4ff" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#00d4ff" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="rgba(255,255,255,0.06)" vertical={false} />
          <XAxis
            dataKey="t"
            tick={{ fill: "#6b6b73", fontSize: 11 }}
            axisLine={{ stroke: "rgba(255,255,255,0.08)" }}
            tickLine={false}
          />
          <YAxis
            domain={[0, 100]}
            tick={{ fill: "#6b6b73", fontSize: 11 }}
            axisLine={false}
            tickLine={false}
            tickFormatter={(v) => `${v}%`}
          />
          <Tooltip
            cursor={{ stroke: "rgba(0,212,255,0.25)" }}
            contentStyle={{
              background: "#13131a",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 6,
              fontSize: 12,
              color: "#e8e8ec",
            }}
            formatter={(v: number) => [`${v}%`, "完成率"]}
            labelStyle={{ color: "#9b9ba1" }}
          />
          <Area
            type="monotone"
            dataKey="completion"
            stroke="#00d4ff"
            strokeWidth={2}
            fill="url(#completionFill)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
